import React, { useEffect, useRef } from "react";
import "leaflet/dist/leaflet.css";

const pin = (L, label, color) => L.divIcon({
  className: "",
  html: `<div style="width:28px;height:28px;border-radius:50%;background:${color};color:#F7F3EA;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;font:600 13px/1 sans-serif">${label}</div>`,
  iconSize: [28, 28], iconAnchor: [14, 14],
});

// a, b = [lon, lat]; line = [[lat, lon], ...]
export const RouteMap = ({ a, b, line, className = "h-56", testid = "route-map" }) => {
  const el = useRef(null);
  const map = useRef(null);
  useEffect(() => {
    let alive = true;
    import("leaflet").then(({ default: L }) => {
      if (!alive || !el.current) return;
      if (!map.current) {
        map.current = L.map(el.current, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 18, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> contributors',
        }).addTo(map.current);
      }
      const m = map.current;
      m.eachLayer((l) => { if (!(l instanceof L.TileLayer)) m.removeLayer(l); });
      const A = [a[1], a[0]], B = [b[1], b[0]];
      L.marker(A, { icon: pin(L, "A", "#183C35") }).addTo(m);
      L.marker(B, { icon: pin(L, "B", "#3E7F8E") }).addTo(m);
      const pts = line && line.length > 1 ? line : [A, B];
      const poly = L.polyline(pts, { color: "#3E7F8E", weight: 5, opacity: 0.85, dashArray: line ? null : "6 8" }).addTo(m);
      m.fitBounds(poly.getBounds(), { padding: [28, 28] });
      setTimeout(() => m.invalidateSize(), 50);
    });
    return () => { alive = false; };
  }, [a, b, line]);
  useEffect(() => () => { map.current?.remove(); map.current = null; }, []);
  return <div ref={el} className={`w-full rounded-xl overflow-hidden border border-[#183C35]/10 z-0 ${className}`} data-testid={testid} />;
};
